import React from "react";
import { Paper, Typography } from "@mui/material";
import MuiPieChart from "./MuiPieChart.tsx";

const StatusPieChart = () => {
  const data = [
    { id: 1, value: 29.2, label: "Converted", color: "#00c853" },
    { id: 2, value: 23.4, label: "New", color: "#2979ff" },
    { id: 3, value: 24.0, label: "Qualified", color: "#ffa000" },
    { id: 4, value: 23.4, label: "Lost", color: "#d50000" },
  ];

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Status Distribution
      </Typography>
      <MuiPieChart data={data} />
    </Paper>
  );
};

export default StatusPieChart;
